import React from "react"
import {CheckDepositRiskFlag} from "../../resources/checkDeposits"
import Card from "../../containers/Card/Card"

interface CheckDepositRiskFlagsProps {
	riskFlags?: CheckDepositRiskFlag[]
}

export function CheckDepositRiskFlags({riskFlags}: CheckDepositRiskFlagsProps) {
	return (
		<div className={"check-deposit-risk-flags-container"}>
			{riskFlags?.map((riskFlag, idx) => (
				<Card key={`${riskFlag.name}/${idx}`} title={riskFlag.name}>
					{riskFlag.description}
					{riskFlag.resolution}
				</Card>
			))}
		</div>
	)
}
